<template>
  <editor :id="id" default-tab="list_data_import" :tabs="tabs"></editor>
</template>

<script>
import Editor from '@/components/Editor'
import Basic from './list_data/Import'

export default {
  props: ['id'],
  components: {
    Editor
  },
  data () {
    return {
      tabs: [
        {title: "List data import", name: "list_data_import", component: Basic},
      ]
    }
  }
}
</script>
